import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import GeneralUpdateListLayer from "../components/GeneralUpdateListLayer";

const GeneralUpdatePage = () => {
    return (
        <MasterLayout>
            <GeneralUpdateListLayer />
        </MasterLayout>
    );
};

export default GeneralUpdatePage;
